import { toKey } from './composition.js';

export const setupMock = () => {
	const createBasketItem = ({ quantity, key }) => ({
		name: 'Ноутбук Ultra',
		article: '270-01-01',
		pictureSrc: '../images/content/cart-product-1.webp',
		quantity: quantity,
		availableQuantity: 10,
		basketId: key,
		productId: key,
		basePricePerItemFormatted: '20&nbsp;800 &#8381;',
		pricePerItemFormatted: '10&nbsp;304 &#8381;',
	});

	const createFavouritesData = (action, cnt) => ({
		status: 'success',
		data: {
			error:'',
			action,
			cnt,
		},
		errors: []
	});

	const createBasketData = (basketItems) => ({
		status: 'success',
		data: {
			basketData: {
				basketItems,
				basketSummary: {
					productsCount: Object.values(basketItems).length
				}
			},
		},
		errors: [],
	});

	window.BX = {
		mock: true,
		ajax: {
			runAction: (action, data) => {
				if (action === 'o2k:sitecore.api.favorites.get') {
					return Promise.resolve({
						status: 'success',
						data: {
							ids: JSON.parse(localStorage.getItem('favourites')) || {},
						},
						errors: []
					});
				}

				if (action === 'o2k:sitecore.api.favorites.change') {
					const favs = {...(JSON.parse(localStorage.getItem('favourites')) || {})};
					const key = toKey(data.data.productId);
					const favAction = favs[key] ? 'delete' : 'add';
					if (favAction === 'add') favs[key] = key;
					else delete favs[key];
					localStorage.setItem('favourites', JSON.stringify(favs));
					const cnt = Object.keys(favs).length;
					return Promise.resolve(createFavouritesData(favAction, cnt));
				}

				if (action === 'o2k:sitecore.api.Basket.getBasket') {
					const cart = {...(JSON.parse(localStorage.getItem('cart')) || {})};
					return Promise.resolve(createBasketData(cart));
				}

				if (action === 'o2k:sitecore.api.Basket.addProduct' || action === 'o2k:sitecore.api.Basket.setProductQuantity') {
					const cart = {...(JSON.parse(localStorage.getItem('cart')) || {})};
					const key = toKey(data.data.productId);
					const { quantity } = data.data;
					cart[key] = createBasketItem({ quantity, key });
					localStorage.setItem('cart', JSON.stringify(cart));
					return Promise.resolve(createBasketData(cart));
				}

				if (action === 'o2k:sitecore.api.Basket.removeProduct') {
					const cart = {...(JSON.parse(localStorage.getItem('cart')) || {})};
					const key = toKey(data.data.productId);
					delete cart[key];
					localStorage.setItem('cart', JSON.stringify(cart));
					return Promise.resolve(createBasketData(cart));
				}
			},
		}
	};
};
